import type { TracedLayout } from '../traced';

/**
 * Layout traced from a top-down overview image of a well-known map (`cs_inferno_radar.png`) by tools/trace-map.py:
 * `#` wall, `.` floor, `c` low cover, run-length encoded (`12#` = twelve walls). Cells are 0.5 m; the longest side is 80.0 m.
 * The image itself is not in the repository.
 */
export const INFERNO_LAYOUT: TracedLayout = {
  cell: 0.5,
  width: 160,
  height: 157,
  spawns: [{ x0: 1.1, z0: 99.6, x1: 12.6, z1: 121.0 }, { x0: 144.4, z0: 41.1, x1: 155.4, z1: 66.7 }],
  sites: [{ x0: 67.3, z0: 21.8, x1: 84.8, z1: 38.3 }, { x0: 127.9, z0: 102.4, x1: 141.4, z1: 123.6 }],
  rows: [
    '77#16.67#',
    '77#16.67#',
    '77#16.67#',
    '77#16.#8.58#',
    '78#15.#9.57#',
    '78#24.58#',
    '78#24.58#',
    '78#24.58#',
    '78#24.58#',
    '78#24.58#',
    '78#27.4#2.49#',
    '78#33.49#',
    '63#4.11#34.48#',
    '63#4.11#34.48#',
    '63#49.48#',
    '63#49.48#',
    '63#49.48#',
    '63#49.48#',
    '63#49.48#',
    '63#49.48#',
    '63#54.43#',
    '63#31.9#14.43#',
    '63#31.9#18.6#9.24#',
    '63#31.9#34.6#3.14#',
    '63#31.9#36.4#3.14#',
    '63#31.9#37.#5.14#',
    '63#31.9#43.14#',
    '63#31.9#43.14#',
    '63#31.9#43.14#',
    '63#85.12#',
    '63#85.12#',
    '63#85.12#',
    '63#85.12#',
    '63#85.12#',
    '63#85.#.10#',
    '63#87.10#',
    '63#87.10#',
    '63#87.10#',
    '63#87.10#',
    '63#87.10#',
    '63#93.4#',
    '63#93.4#',
    '63#4.#88.4#',
    '87#69.4#',
    '87#69.4#',
    '87#69.4#',
    '87#69.4#',
    '87#69.4#',
    '87#11.22#36.4#',
    '87#11.22#36.4#',
    '87#11.22#36.4#',
    '87#11.22#5.17#14.4#',
    '76#.10#11.22#5.17#14.4#',
    '76#22.22#5.17#14.4#',
    '76#22.22#5.17#14.4#',
    '75#23.22#5.17#14.4#',
    '75#23.22#5.17#14.4#',
    '75#23.22#5.17#13.5#',
    '73#25.22#5.17#13.5#',
    '74#24.22#5.17#13.5#',
    '73#28.19#35.5#',
    '72#29.19#35.5#',
    '72#29.19#35.5#',
    '72#29.19#36.4#',
    '71#30.19#36.4#',
    '71#84.5#',
    '70#85.5#',
    '70#83.7#',
    '69#83.8#',
    '69#10.41#32.8#',
    '68#10.42#32.8#',
    '68#8.44#31.9#',
    '67#9.44#31.#5.3#',
    '65#9.48#.2#7.13#12.3#',
    '65#9.51#7.13#12.3#',
    '65#10.50#7.13#12.3#',
    '63#11.51#7.13#12.3#',
    '63#11.51#7.13#12.3#',
    '61#13.51#7.13#12.3#',
    '61#13.51#7.13#12.3#',
    '61#13.51#7.13#12.3#',
    '61#13.51#7.13#12.3#',
    '65#9.51#7.13#15.',
    '65#9.34#8.2#14.3#25.',
    '65#9.34#52.',
    '65#5.38#52.',
    '65#5.38#52.',
    '65#5.39#51.',
    '65#5.41#49.',
    '65#5.41#49.',
    '65#5.41#49.',
    '65#5.41#49.',
    '65#5.41#48.#',
    '65#5.41#44.5#',
    '65#5.41#24.6#14.5#',
    '65#5.41#8.22#14.5#',
    '44#3.#22.41#8.22#14.5#',
    '44#26.41#8.22#19.',
    '45#25.41#8.22#19.',
    '#11.31#27.39#10.22#19.',
    '#13.19#37.39#10.22#19.',
    '#13.18#38.39#10.22#19.',
    '#13.18#47.30#10.9#32.',
    '#12.19#19.12#35.12#9.9#32.',
    '#12.19#18.14#34.12#9.9#22.10#',
    '13.19#18.14#34.12#9.9#22.10#',
    '13.19#18.13#35.12#9.9#23.9#',
    '13.3#7.9#18.14#55.9#22.10#',
    '13.3#34.14#55.9#23.9#',
    '13.3#35.13#55.9#29.3#',
    '13.2#35.14#55.9#29.3#',
    '13.2#104.9#29.3#',
    '13.2#104.9#29.3#',
    '13.3#6.10#87.9#29.3#',
    '#21.10#33.24#30.9#31.#',
    '#21.10#33.24#9.2#19.9#30.2#',
    '#21.10#33.24#9.7#14.9#30.2#',
    '22.10#33.24#9.7#14.9#30.2#',
    '22.10#33.24#9.7#14.9#30.2#',
    '22.10#33.24#9.7#14.9#30.2#',
    '65.24#9.7#14.9#30.2#',
    '#64.24#9.7#53.2#',
    '#64.24#9.7#53.2#',
    '#74.14#9.7#54.#',
    '#74.14#9.7#54.#',
    '76.13#9.7#54.#',
    '76.13#9.7#54.#',
    '#75.13#70.#',
    '#158.#',
    '#158.#',
    '2#157.#',
    '2#157.#',
    '#158.#',
    '2#110.16#31.#',
    '6#103.19#30.2#',
    '6#8.#94.19#31.#',
    '6#6.4#93.19#31.#',
    '17#92.19#31.#',
    '17#142.#',
    '17#24.6#30.15#67.#',
    '16#25.6#30.15#66.2#',
    '15#26.6#30.15#6.5#55.2#',
    '15#26.6#30.15#6.5#54.3#',
    '15#26.6#30.15#6.6#53.3#',
    '15#23.#2.6#30.15#6.7#52.3#',
    '23#15.9#30.14#7.7#51.4#',
    '23#8.3#2.#.9#30.14#7.7#49.#.4#',
    '23#5.19#14.6#10.14#7.7#48.7#',
    '47#11.15#4.14#7.7#4.28#8.5#3.7#',
    '47#5.21#7.11#7.2#9.51#',
    '47#5.21#37.50#',
    '47#5.21#87.',
    '73#87.',
    '73#87.',
    '73#27.9#51.',
    '73#27.60#',
    '92#8.60#',
  ],
};
